<template>
  <ChangeLog
    :title="inventoryItem.name"
    :editRoute="`/inventory/type/${currentType.id}/item/${inventoryItem.id}`"
    collection="inventoryItems"
    :docID="currentID"
    >
</ChangeLog>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex' // eslint-disable-line

import ChangeLog from '@/components/ChangeLog'

export default {
  name: 'ItemHistory',
  components: {
    ChangeLog
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters('inventory', {
      currentType: 'types/currentType',
      currentID: 'items/currentID',
      inventoryItem: 'items/currentItem'
    })
  },
  methods: {
  }
}
</script>

<style>
</style>
